export default {
  content: ''+
  '<div class="text-box">'+
  '<p class="text-line">（1）参赛选手将无人机启动后安置在起飞区域，然后进入操控区域，戴好护目镜并启动控制台做起飞前的检查。</p>'+
  '<p class="text-line">（2）通过观看无人机传回的画面，使用飞行操纵杆控制飞机起飞。</p>'+
  '<p class="text-line">（3）完成指定的障碍穿越，在飞行路线中侦察数字牌，并纪录数字牌上的数字。</p>'+
  '<p class="text-line">（4）在规定时间内完成飞行，并且要降落在指定区域内，飞机停稳后，飞机断电，控制台断电，参赛选手自行取回飞机。</p>'+
  '<p class="text-line">（5）降落后向裁判员提交填写完成的侦察单，结束比赛。</p>'+
  '<p class="text-line">赛场示意图如下:</p>'+
  '<img class="img-line" src="/work/static/img/uva/GKZ/t31.jpg" width="100%" />' +
  '<img class="img-line" src="/work/static/img/uva/GKZ/t32.jpg" width="100%" />' +

  '</div>'
}